import React, { useState, useEffect } from "react";
import CreatableSelect from 'react-select/creatable';
import ListBox from "../form-elements/ListBox";
import { CONTRACTOR_ROLE_URL, CONTRACTOR_ROLE_WITH_ID_URL, OBSERVATION_TYPES, OBSERVATION_TYPES_WITH_ID_URL } from "../constants";

import { Modal, Button, Form } from 'react-bootstrap';
import cogoToast from 'cogo-toast';
import LocationList from "../form-elements/LocationList";
import { deletePopup, singlePopup } from "../notifications/Swal";
import { Alert } from "react-bootstrap";
import SubmitCard from "../dashboard/SubmitCard";
import AddItem from "../form-elements/AddItem";
import API from "../services/API";

const ObsSource = () => {


    const [tier1, setTier1] = useState([]);
    const [selectedTier1, setSelectedTier1] = useState({ id: '' });


    useEffect(() => { getContractor() }, [])

    const getContractor = async () => {
        const response = await API.get(OBSERVATION_TYPES);
        if (response.status === 200) {
            const tier1 = response.data;
            setTier1(tier1);
        }
    }


    const handleTier1Select = (id) => {
        setSelectedTier1(tier1.find(i => i.id === id))
    }

    const createTier1 = async (value) => {
        const response = await API.post(OBSERVATION_TYPES, { name: value })
        if (response.status === 200) {
            const createdTier1 = response.data;
            setTier1((prev) => [...prev, createdTier1]);
            cogoToast.info('Created!', { position: 'top-right' })

        }

    }





    const handleDeleteItem = async (mode, id) => {

        deletePopup.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            reverseButtons: true,

            confirmButtonText: 'Delete'
        }).then(async (result) => {
            if (result.isConfirmed) {
                //   deleteChecklist(id);

                const response = await API.delete(OBSERVATION_TYPES_WITH_ID_URL(id))

                if (response.status === 204) {

                    setTier1(prev => prev.filter(i => i.id !== id))
                    setSelectedTier1({ id: '' });

                    singlePopup.fire(
                        'Deleted!',
                        '',
                        'success'
                    );
                }

            }
        })

    }

    const handleEditItem = async (id, name) => {
        const response = await API.patch(OBSERVATION_TYPES_WITH_ID_URL(id), { name: name })
        if (response.status === 204) {
            cogoToast.success('Updated!')
        }
    }


    return (
        <>
            <div className="">
                <div className="col-lg-12 p-0">

                    <h4 className="card-title mb-3">Configure Contractors</h4>



                    <>
                        <div className="row">
                            <div className="col-4 p-1 ps-3">
                                <ListBox handleDeleteItem={handleDeleteItem} selected={'true'} handleEditItem={handleEditItem} title={'Contractors'} onHandleCreateItem={createTier1} lists={tier1} handleSelect={handleTier1Select} selectedItem={selectedTier1} mode='tier1' />
                            </div>



                        </div>
                    </>






                </div>
            </div>




        </>
    );

}

export default ObsSource;